import { render, staticRenderFns } from "./StudentData.vue?vue&type=template&id=965904c8"
import script from "./StudentData.vue?vue&type=script&lang=js"
export * from "./StudentData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports